<script lang="ts">
import type { ModalProps } from '@kelan-ui/vue'
import type { ComponentObjectPropsOptions } from 'vue'
import { KLModal as KelanModal } from '@kelan-ui/vue'
import { defineComponent, h } from 'vue'

// Keep the Admin-wide modal positioning policy at this resolver boundary.
const modalProps = {
  ...KelanModal.props,
  alignCenter: {
    ...KelanModal.props.alignCenter,
    default: true,
  },
} as ComponentObjectPropsOptions<ModalProps>

export default defineComponent({
  name: 'KLModal',
  inheritAttrs: false,
  props: modalProps,
  emits: ['update:modelValue', 'open', 'opened', 'close', 'closed', 'confirm', 'cancel'],
  setup(props, { attrs, emit, slots }) {
    return () => h(KelanModal, {
      ...attrs,
      ...props,
      'onUpdate:modelValue': (value: boolean) => emit('update:modelValue', value),
      'onOpen': () => emit('open'),
      'onOpened': () => emit('opened'),
      'onClose': () => emit('close'),
      'onClosed': () => emit('closed'),
      'onConfirm': () => emit('confirm'),
      'onCancel': () => emit('cancel'),
    }, {
      ...(slots.header ? { header: slots.header } : {}),
      ...(slots.default ? { default: slots.default } : {}),
      ...(slots.footer ? { footer: slots.footer } : {}),
    })
  },
})
</script>
